import Firebase from './Firebase';
export * from './FirebaseContext';

export default Firebase;
